import { useContext } from "react";
import { useQuery } from "react-query";
import { getTodaysTotalCustomersReq } from "../../../axios/Manager/Analytics";
import StoreData from "../../../contexts/StoreData";

export const useGetTodaysTotalCustomers = () => {
  const { token } = useContext(StoreData);
  return useQuery(
    ["todays-total-customers"],
    async () => await getTodaysTotalCustomersReq(token),
    {
      retry: 3,
      enabled: !!token,
    }
  );
};
